
const imgUrl = {
    
    'endlogo' : require('./end_tb_logo.png'),
    'durelogo' : require('./durelogo.png'),
    'avatar': require('./avatar.png'),
    'pgmico': require('./pgmico.png'),
    'aids_icon':require('../images/appIcon/pgmico(5).png'),
    'no_mosquito':require('../images/appIcon/no-mosquito.png'),
    'tb_icon':require('../images/appIcon/tb-icon.png'),
    'malaria_icon':require('../images/appIcon/malaria-icon.png'),
    'hiv_icon':require('../images/appIcon/HIV-icon.png'),
    'sickle_icon':require('../images/appIcon/sickle.png'),
}

export default imgUrl;